import * as Sentry from '@sentry/svelte';

const ignoreErrors = [
  'Importing a module script failed',
  'Abort due to cancellation of share',
  'No collector configured',
  'Load failed',
  'Request timeout getDictionariesByLanguageId',
  'Request timeout getSupportScreenShot',
  'Request timeout isDictateAvailable',
  'Request timeout isPredictionAvailable',
  'Request timeout dictionariesDistributor.getValue',
  'Request timeout speechVoicesDistributor.getValue',
  'Request timeout userDistributor.getValue',
  'Request timeout predictionDistributor.getValue',
  'Request timeout dictateStateDistributor.getValue',
  'Request timeout nn-NO_wordsDistributor.getValue',
  'Request timeout availableTextCheckLanguagesDistributor.getValue',
  'Request timeout es_wordsDistributor.getValue',
  'Request timeout lettersVoicesDistributor.getValue',
  'Request timeout topicsDistributor.getValue',
  'Request timeout availableLanguagesDistributor.getValue',
  'Request timeout ac_wordsDistributor.getValue',
  'Request timeout nb-NO_wordsDistributor.getValue',
  'Request timeout ua_wordsDistributor.getValue',
  'Request timeout en_wordsDistributor.getValue',
  'Request timeout appSettingsDistributor.getValue',
  'Request timeout DefineExpirationForLanguagePacks.getValue',
  'Request timeout textCheckersDistributor.getValue',
  'Request timeout de_wordsDistributor.getValue',
  'Request timeout fr_wordsDistributor.getValue',
  'Request timeout ru_wordsDistributor.getValue',
];

export const initSentry = (environment: string) => {
  // eslint-disable-next-line turbo/no-undeclared-env-vars
  if (import.meta.env.PROD) {
    Sentry.init({
      dsn: 'https://13760f5047818a0ab0c8b8ccaacc6515@o124059.ingest.us.sentry.io/4510232836243456',
      integrations: [
        Sentry.browserTracingIntegration(),
        Sentry.browserSessionIntegration(),
        Sentry.captureConsoleIntegration({ levels: ['error'] }),
      ],
      normalizeMaxBreadth: 10,
      normalizeDepth: 3,
      sampleRate: 1, // admin can have 100%
      tracesSampleRate: 0.05,
      environment,
      ignoreErrors,
      // v11 collects user info, cookies, headers and HTTP bodies unless told
      // otherwise. Keep the v10 restrictive baseline: never leave this unset.
      dataCollection: {
        userInfo: false,
        cookies: false,
        httpHeaders: {
          request: { deny: ['forwarded', '-ip', 'remote-', 'via', '-user'] },
          response: { deny: ['forwarded', '-ip', 'remote-', 'via', '-user'] },
        },
        httpBodies: [],
        urlQueryParams: {
          deny: ['forwarded', '-ip', 'remote-', 'via', '-user'],
        },
        genAI: { inputs: false, outputs: false },
        databaseQueryData: false,
        queues: false,
        graphQL: { document: false, variables: false },
      },
    });
  }
};
